module.exports = __webpack_public_path__ + "img/5.9440bb3f.jpg";